'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isString = require('is-string');

var _isString2 = _interopRequireDefault(_isString);

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var format = function format(value) {
  return (0, _isString2.default)(value) ? value.replace(/[^a-z0-9]/gi, '').slice(0, 7).toUpperCase() : '';
};

var validate = function validate(value) {
  return /^[A-Z0-9]{7}$/.test(value);
};

exports.default = (0, _type2.default)({
  type: 'string',
  format: format,
  validate: validate
});